var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorboltLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 292.82 281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke:#1d1d1b;stroke-miterlimit:10;}.cls-2{fill:#654670;}.cls-3{fill:none;}.cls-4{fill:#f8e923;stroke-width:0.5px;}.cls-5{fill:#fff;}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 152.32,
    cy: 140.5,
    r: 140
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 152.32,
    cy: 140.5,
    r: 134
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.66,281.23a5,5,0,0,0,5,5h94.68a5,5,0,0,0,0-10H279.66a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.66,281.23a5,5,0,0,0,5,5h94.68a5,5,0,0,0,0-10H279.66a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140,312.06a5,5,0,0,0,5,5H292.64a5,5,0,0,0,0-10H145a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140,312.06a5,5,0,0,0,5,5H292.64a5,5,0,0,0,0-10H145a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.25,376.72a5,5,0,0,0,5,5H391a5,5,0,0,0,0-10H220.25a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.25,376.72a5,5,0,0,0,5,5H391a5,5,0,0,0,0-10H220.25a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.58,441.39a5,5,0,0,0,5,5H309.89a5,5,0,0,0,0-10H182.58a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.58,441.39a5,5,0,0,0,5,5H309.89a5,5,0,0,0,0-10H182.58a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.89,344.39a5,5,0,0,0,5,5h84a5,5,0,0,0,0-10h-84a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.89,344.39a5,5,0,0,0,5,5h84a5,5,0,0,0,0-10h-84a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.4,254.71a5,5,0,0,0,5,5h85.66a5,5,0,0,0,0-10H203.4a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.4,254.71a5,5,0,0,0,5,5h85.66a5,5,0,0,0,0-10H203.4a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.56,405.57a5,5,0,0,0,5,5H313.31a5,5,0,0,0,0-10H142.56a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.56,405.57a5,5,0,0,0,5,5H313.31a5,5,0,0,0,0-10H142.56a5,5,0,0,0-5,5Z",
    transform: "translate(-109.68 -212.5)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M384.21,267.52a6,6,0,0,0-3.89-3.69,6.4,6.4,0,0,0-5.38,1,5.49,5.49,0,0,0-.15-9.27,6.33,6.33,0,0,0,5.41.81,6,6,0,0,0,3.77-3.81,5.66,5.66,0,0,0,.87,5.17,6.31,6.31,0,0,0,5,2.25,6.31,6.31,0,0,0-4.88,2.39A5.65,5.65,0,0,0,384.21,267.52Z",
    transform: "translate(-109.68 -212.5)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M402.15,271.19",
    transform: "translate(-109.68 -212.5)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M245.3,469.83a6,6,0,0,0-4.47-2.95,6.36,6.36,0,0,0-5.13,1.9,5.49,5.49,0,0,0-1.78-9.1,6.39,6.39,0,0,0,5.47-.16,5.94,5.94,0,0,0,3-4.41,5.66,5.66,0,0,0,1.77,4.93,6.26,6.26,0,0,0,5.27,1.34,6.28,6.28,0,0,0-4.38,3.21A5.68,5.68,0,0,0,245.3,469.83Z",
    transform: "translate(-109.68 -212.5)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.22,315.14a6,6,0,0,0-3-4.47,6.4,6.4,0,0,0-5.46-.26,5.82,5.82,0,0,0,3.45-4,5.88,5.88,0,0,0-1.53-5.07,6.37,6.37,0,0,0,5.1,2,6,6,0,0,0,4.51-2.88,5.7,5.7,0,0,0-.3,5.24,6.26,6.26,0,0,0,4.33,3.29,6.29,6.29,0,0,0-5.29,1.24A5.65,5.65,0,0,0,118.22,315.14Z",
    transform: "translate(-109.68 -212.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorboltLogo);
export default __webpack_public_path__ + "static/media/storbolt-logo.2bf0657d023751c3e8f373d5487b90b8.svg";
export { ForwardRef as ReactComponent };